class OnDemandLoader {
    // if you have something that's loaded on demand, you can still load it lazyily on first page hit via waitForPageLoad
    /**
     *
     * @param {Array} src - Array of Objects [{ src:[String], attr: {key:[String]} }]
     * @param {Boolean} waitForPageLoad
     * @param {Function} beforeLoadCallback
     */
    constructor(src, waitForPageLoad = true, beforeLoadCallback) {
        this.isLoaded = false
        this.isLoading = false
        this.callbacks = []
        this.srcs = src
        this.loadCount = 0
        this.waitForPageLoad = waitForPageLoad
        this.hasError = false
        this.errorCallbacks = []
        this.calledErrorCallbacks = false
        if (beforeLoadCallback) this.callbacks.push(beforeLoadCallback)
    }

    load(callback = null, errorCallback = null) {
        if (!callback) return
        if (this.isLoaded) callback()
        else {
            this.callbacks.push(callback)
            if (errorCallback) this.errorCallbacks.push(errorCallback)
            if (!this.isLoading) {
                this.isLoading = true
                if (!this.waitForPageLoad || document.readyState === 'complete') this._loadScript()
                else window.addEventListener('load', () => this._loadScript())
            }
        }
    }

    _invokeErrorCallbacks() {
        if (this.calledErrorCallbacks) return
        this.errorCallbacks.forEach((callback) => callback())
        this.calledErrorCallbacks = true
    }

    _loadScript() {
        if (this.hasError) return
        this.srcs.forEach((src) => {
            const script = document.createElement('script')
            for (const key in src) {
                script.setAttribute(key, src[key])
            }
            script.onload = () => {
                if (this.hasError) return
                this.loadCount++
                if (this.srcs.length === this.loadCount) this._invokeCallbacks()
            }
            script.onerror = () => {
                this.hasError = true
                this._invokeErrorCallbacks()
            }
            document.getElementsByTagName('head')[0].appendChild(script)
        })
    }

    _invokeCallbacks() {
        this.isLoaded = true
        this.callbacks.forEach((callback) => callback())
        this.callbacks = []
        this.isLoading = false
    }
}

const onDemandCallbackLoader = (callback) => {
    let hasBeenCalled = false

    function load() {
        if (hasBeenCalled) return
        hasBeenCalled = true
        callback()
    }

    return { load }
}

const onLoadLoader = (callback, delay = 1) => {
    // missed the load event, run now
    if (document.readyState === 'complete') {
        setTimeout(() => callback(), delay)
    } else {
        window.addEventListener('load', function () {
            setTimeout(() => callback(), delay)
        })
    }
}

const onNuxtReadyLoader = (callback, delay = 0) => {
    let hasBeenCalled = false

    function callbackWrapper() {
        if (hasBeenCalled) return
        hasBeenCalled = true
        callback()
    }

    window.onNuxtReady(() => {
        setTimeout(callbackWrapper, delay)
    })

    return callbackWrapper
}

export default {
    OnDemandLoader,
    onDemandCallbackLoader,
    onLoadLoader,
    onNuxtReadyLoader,
}
